<template>
  <div class="page-box">
    <div class="right">
      <div class="opt-btn">
        <div class="title">互斥规则：两个不同的组别类型之间，选手不能同时兼报</div>
        <el-button type="danger" size="mini" @click="addRules()"
          >新增规则</el-button
        >
      </div>
      <div class="table-box" :style="{ '--height': height }">
        <el-table
          :data="tableData"
          ref="tableRef"
          highlight-current-row
          :header-cell-style="{
            background: '#e4e4e4',
            border: 'none',
            color: '#000000',
            fontWeight: 'bolder',
            fontSize: '0.8rem',
            padding: '0.5rem',
          }"
          :cell-style="{ padding: '0.3rem', fontSize: '0.8rem' }"
          current-row-key="id"
          border
          style="width:100%;height: calc(100%);overflow-y: hidden;font-size: 0.8rem;"
        >
          <el-table-column prop="currGroupClassifyName" label="当前组别分类" width="240px">
          </el-table-column>
          <el-table-column prop="mutualExclusionGroupClassifyName" label="禁报组别分类">
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="140px" align="center">
          </el-table-column>
          <el-table-column prop="" label="操作" align="center" width="80px">
            <template slot-scope="{row}">
              <el-button type="text" @click="deleteItemType(row)" size="mini">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="" align="center" width="auto"></el-table-column>
        </el-table>
      </div>
      <!-- <div class="page">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10,20,30, 40, 80, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
        >
          :pager-count="5">
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
import AddGroupmutRules from "./add-group-mutrules.vue";
import { openDialog } from "../../../../../../../components/fn-dialog";
import { deleteMutualExclusionRuleById, pageMutualExclusionRules } from "../../../../../api/mymatchs/groupsetitem";
export default {
  name: "group-type",
  data() {
    return {
      totalNum: 0,
      pageSize: 300,
      currentPage: 1,
      height: "100%",
      tableData: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.height = this.$refs.tableRef.$el.clientHeight + "px";
      const matchId = this.$route.query.matchId;
      if (matchId) {
        this.matchId = matchId;
        this.getTableData();
      }
    }, 100);
  },
  beforeDestroy() {},
  methods: {
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getTableData();
    },
    currentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    addRules() {
      openDialog(AddGroupmutRules, {
        title: "新增互斥规则",
        width: "450px",
        height: "100px",
        params:{
          matchId:this.matchId,
          tableData:this.tableData,
        },
        callback: () => {
          this.currentPage = 1;
          this.getTableData();
        }
      });
    },
    deleteItemType(row) {
      this.$confirm("确定要删除该条数据吗？", "提示").then(async(confirm) => {
        if(confirm === 'confirm'){
          const res = await deleteMutualExclusionRuleById({id:row.id});
          if(res && res.status == 200) {
            this.$message.success("删除成功");
            this.getTableData();
          }else{
            res && res.msg && this.$message.error(res.msg);
          }
        }
      });
    },
    async getTableData() {
      const params = {
        currPage: this.currentPage,
        pageSize: this.pageSize,
        matchId: this.matchId,
      };
      const res = await pageMutualExclusionRules(params);
      if (res && res.status == 200) {
        this.totalNum = res.data.total;
        this.tableData = res.data.list;
      } else {
        res && res.msg && this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  width: calc(100%);
  height: calc(100%);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  .left {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px 1fr;
    .opt-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 15px;
    }
    .table-box {
      background-color: #fff;
    }
    .page {
      background-color: #fff;
      box-shadow: 0px -2px 8px #f2f2f2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 15px;
    }
  }
  .right {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px 1fr;
    .opt-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      .title{
        color: #7F7F7F;
        font-size: 14px;
      }
    }
    .table-box {
      background-color: #fff;
      height: calc(var(--height));
      overflow: hidden;

      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 37px);
        overflow-y: auto;
      }
    }
    .page {
      background-color: #fff;
      box-shadow: 0px -2px 8px #f2f2f2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 15px;
    }
  }
  ::v-deep .el-button--danger {
    background-color: #f32c6c;
  }
}
</style>
